module.exports = __webpack_public_path__ + "img/design-forward-stock-prices.adf235b1.svg";